export default "__VITE_ASSET__a822fa57__"